<template>
    <div class="cookies-panel">
        <div class="cookies-panel__settings">
            <div class="cookies-panel__settings--wrapper">
                <div class="settings__title">
                    <h6>{{text.cookies.cookies_policy.title}} </h6>
                    <label class="cookie-switch">
                        <input type="checkbox" disabled checked>
                        <span class="cookie-switch--slider cookie-switch--locked"></span>
                    </label>
                </div>
            </div>
            <div class="cookies-panel__settings--wrapper">
                <div class="settings__title">
                    <h6>{{text.cookies.performance.title}}</h6>
                    <label class="cookie-switch">
                        <input @click.stop type="checkbox" value="performance" v-model="checkedCookies">
                        <span class="cookie-switch--slider"></span>
                    </label>
                </div>
            </div>
            <div class="cookies-panel__settings--wrapper">
                <div class="settings__title">
                    <h6>{{text.cookies.marketing.title}}</h6>
                    <label class="cookie-switch">
                        <input @click.stop type="checkbox" value="marketing" v-model="checkedCookies">
                        <span class="cookie-switch--slider"></span>
                    </label>
                </div>
            </div>

            <button class="btn" type="submit" @click="submit">{{ text.button.confirm }}</button>
        </div>
    </div>
</template>

<script>
const cookie = require('cookie_js')

export default {
    name: 'cookies-panel',
    data () {
        return {
            checkedCookies: ['cookie_policy'],
            text: {
                cookies: {
                    cookies_policy: {
                        title: localize({
                            'ru': 'Обязательные cookies',
                            'en': 'Strictly necessary cookies'
                        }),
                        description: localize({
                            'ru': 'Эти файлы необходимы для правильной работы сайта и&nbsp;функционала.',
                            'en': 'These cookies are essential for the website and its features to work properly.'
                        })
                    },
                    performance: {
                        title: localize({
                            'ru': 'Эксплуатационные cookies',
                            'en': 'Performance cookies'
                        }),
                        description: localize({
                            'ru': 'Эти файлы собирают информацию о&nbsp;том, как вы&nbsp;используете сайт, и&nbsp;помогают нам улучшать его в&nbsp;соответствии с&nbsp;вашими потребностями.',
                            'en': 'These cookies collect information about how you use the website and help&nbsp;us to&nbsp;adapt the content according to&nbsp;your needs, improving its usability.'
                        })
                    },
                    marketing: {
                        title: localize({
                            'ru': 'Маркетинговые cookies',
                            'en': 'Marketing cookies'
                        }),
                        description: localize({
                            'ru': 'Эти файлы используются для показа рекламной информации, которая может быть вам интересна, в&nbsp;частности, на&nbsp;основе посещенных вами сайтов.',
                            'en': 'These cookies are used to&nbsp;send advertising and promotional information that is&nbsp;relevant to&nbsp;you, e.g. based on&nbsp;the web pages you visited.'
                        })
                    }
                },
                button: {
                    confirm: localize({
                        'ru': 'Принять',
                        'en': 'Accept'
                    })
                }
            }
        }
    },
    mounted () {
        this.checkCookies()
    },
    methods: {
        checkCookies () {
            this.checkedCookies = ['cookie_policy']
            let cookies = cookie.get(['performance', 'marketing'])
            Object.keys(cookies).forEach(key => {
                if (cookies[key] === 'true' && !this.checkedCookies.indexOf(key) >= 0) {
                    this.checkedCookies.push(key)
                }
            })
        },
        submit () {
            cookie.set({
                cookies_policy: true,
                performance: this.checkedCookies.indexOf('performance') >= 0,
                marketing: this.checkedCookies.indexOf('marketing') >= 0,
            }, {
                domain: '.' + location.host,
                path: '/',
                expires: 365
            })

            window.location.reload()
        }
    }
}
</script>

<style src="./cookies-panel.scss"></style>



// WEBPACK FOOTER //
// frontend/components/cookies-panel/cookies-panel.vue